import { basesFor, type BuilderIngredient, type PizzaBase, type PizzaConfig } from '@agos/shared'

/**
 * What *Predvolený základ* offers - FRONTEND.md §9.708, FB-1012.
 *
 * The same `basesFor` list every builder reads (§9.681): the *Suroviny - Základ* rows, and the old
 * `config.bases` only for a franchise with no such row. This read `config.bases` directly, so the setting offered
 * bases no builder shows.
 *
 * `stale` is a stored default that is no longer among them - shown as such rather than as a blank select.
 */
export function defaultBaseOptions(
  config: PizzaConfig,
  /** The raw `GET /pizza-ingredients` payload - `NewOrderPage`'s own cast, so the generated type's optional `id` fits. */
  ingredients: unknown,
): { options: PizzaBase[]; stale: string | null } {
  const rows = Array.isArray(ingredients) ? (ingredients as BuilderIngredient[]) : []
  const options = basesFor(config, rows)
  const stored = (config.defaultBaseValue ?? '').trim()
  const stale = stored !== '' && !options.some((base) => base.value === stored) ? stored : null
  return { options, stale }
}
